import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IField } from '../../../models/field/field.model';

@Component({
    selector: 'mat-generic-input-slot',
    templateUrl: './generic-input-slot.component.html',
    styleUrls: [ '../generic-inputs/base-generic-input/base-generic-input.component.scss', './generic-input-slot.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericInputSlotComponent<T> {

    @Input()
    public field: IField;

    @Input()
    public control: AbstractControl<T>;

    @Input()
    public fieldAddonTemplates: TemplateRef<unknown>[];

    @Output()
    public hover: EventEmitter<string> = new EventEmitter<string>();

    constructor() {
    }
}
